import React from 'react';
import { useUpdatePatientStatusContext } from 'components/modals/UpdatePatientStatusModal';
import { Flex } from '@clariness/flex';
import { Text } from '@clariness/text';
import { RadioButton } from '@clariness/radio-button';
import { FormattedMessage } from 'react-intl';
import { UpdateStatusLayout } from '../UpdateStatusLayout/UpdateStatusLayout';
import { ReferralStatus } from 'global/referralStatus';
import { ScreenerDropReasonAtSiteDto } from 'common/api/models/ScreenerDropReasonAtSiteDto';

interface Props {
  dropReasons: ScreenerDropReasonAtSiteDto[];
}

export const DropReason = ({ dropReasons }: Props) => {
  const { selectedStatus, setSelectedDropReason } =
    useUpdatePatientStatusContext();

  return (
    <UpdateStatusLayout heading="">
      <Flex
        gap={3}
        sx={{
          alignItems: 'center',
          height: '30px',
        }}
      >
        <Flex
          sx={{
            marginTop: '10px',
          }}
        >
          <Text variant="pBold">
            {selectedStatus ===
              ReferralStatus.DROPPED__FAILED_IN_EXCLUSION_CRITERIA && (
              <FormattedMessage
                id="is.update_referral_status.dropped_failed_in_exclusion_criteria.title"
                defaultMessage="Failed In-/Exclusion Criteria"
              />
            )}
            {selectedStatus === ReferralStatus.DROPPED__NOT_INTERESTED && (
              <FormattedMessage
                id="is.update_referral_status.dropped_not_interested.title"
                defaultMessage="Not interested"
              />
            )}{' '}
            -{' '}
            <FormattedMessage
              id="is.update_referral_status.drop_reason"
              defaultMessage="please select a reason"
            />
          </Text>
        </Flex>
      </Flex>
      {dropReasons?.map((dr) => (
        <Flex
          key={dr.id}
          gap={3}
          sx={{
            alignItems: 'center',
            height: '30px',
            marginTop: '20px',
          }}
        >
          <RadioButton
            name="droppedReason"
            id={dr.id}
            value={dr.reason}
            onChange={() => {
              setSelectedDropReason(dr.id as string);
            }}
          />
          <Text variant="p">{dr.reason}</Text>
        </Flex>
      ))}
    </UpdateStatusLayout>
  );
};
